import type { AchievementDef } from '../types';

export const ACHIEVEMENTS: AchievementDef[] = [
  { id: 'first_run', title: 'First Run', description: 'Finish your first Quick Run.' },
  { id: 'fare_collector', title: 'Fare Collector', description: 'Collect 50 fares in total.' },
  { id: 'road_survivor', title: 'Road Survivor', description: 'Finish a run with 0 crashes.' },
  { id: 'combo_king', title: 'Combo King', description: 'Reach a x5 fare combo.' },
  { id: 'distance_driver', title: 'Distance Driver', description: 'Travel 5,000m total.' },
];
